/*
 * Copyright (c) 2018-present, Revolut LTD.
 *
 * This source code is licensed under the Apache 2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { mount } from 'enzyme'
import * as React from 'react'
import { Tabs } from '../index'

it('Tabs render', () => {
  const tree = mount(
    <Tabs
      items={[
        {
          id: 'burger',
          title: 'Burger',
          link: '/market/burger',
        },
        {
          id: 'sushi',
          title: 'Sushi',
          link: '/market/sushi',
        },
        {
          id: 'vodka',
          title: 'Vodka',
          link: '/market/vodka',
          disabled: true,
        },
        {
          id: 'pizza',
          title: 'Pizza',
          link: '/market/pizza',
        },
      ]}
      value="pizza"
    />,
  )
  expect(tree).toMatchSnapshot()
})

it('Tabs render with pointer on top', () => {
  const tree = mount(
    <Tabs
      items={[
        {
          id: 'burger',
          title: 'Burger',
          link: '/market/burger',
        },
        {
          id: 'sushi',
          title: 'Sushi',
          link: '/market/sushi',
          titleFunc: item => `Sushi(${item.link})`,
        },
        {
          id: 'pizza',
          title: 'Pizza',
          link: '/market/pizza',
        },
      ]}
      pointerPosition="top"
      value="pizza"
      onChange={() => false}
    />,
  )
  expect(tree).toMatchSnapshot()
})

it('Tabs render with pointer on top and renderItem prop', () => {
  const tree = mount(
    <Tabs
      items={[
        {
          id: 'burger',
          title: 'Burger',
          link: '/market/burger',
        },
        {
          id: 'sushi',
          title: 'Sushi',
          link: '/market/sushi',
        },
        {
          id: 'vodka',
          title: 'Vodka',
          link: '/market/vodka',
          disabled: true,
        },
        {
          id: 'pizza',
          title: 'Pizza',
          link: '/market/pizza',
        },
      ]}
      value="pizza"
      renderItem={({ item, state, handleChange }) => (
        <span
          role="presentation"
          style={{ fontSize: '14px', marginRight: '10px' }}
          key={item.id}
          onKeyDown={() => handleChange(item.id)}
          onClick={() => handleChange(item.id)}
        >
          {item.title}
          {state.value === item.id ? `*` : null}
        </span>
      )}
    />,
  )
  expect(tree).toMatchSnapshot()
})
